import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { LearningPathStatus } from 'enum/learningPathStatus.enum'

export interface LearningPathStateVisual {
  id: LearningPathStatus
  color: string
  icon: IconDefinition
  height: number
}

export const learningPathStateVisuals: LearningPathStateVisual[] = [
  {
    id: LearningPathStatus.draft,
    color: '#D9D9D9',
    icon: faPen,
    height: 28,
  },
  {
    id: LearningPathStatus.published,
    color: '#00B47C',
    icon: faCheckCircle,
    height: 28,
  },
]

/** Misma ruta que el listado (`administration.programs.managePrograms` en locales). */
export const learningPathStateTranslationKey: Record<
  LearningPathStatus,
  string
> = {
  [LearningPathStatus.draft]:
    'administration.programs.managePrograms.table.stateLearningProgram.draft',
  [LearningPathStatus.published]:
    'administration.programs.managePrograms.table.stateLearningProgram.published',
}
